export default __webpack_public_path__ + "static/media/paymiLogo.284343a2.svg";